module.exports = __webpack_public_path__ + "media/icons/email-37400f86.svg";